/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Info_PartnershipsInputs */

const en_footer_info_partnerships = /** @type {(inputs: Footer_Info_PartnershipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partnerships`)
};

/**
* | output |
* | --- |
* | "Partnerships" |
*
* @param {Footer_Info_PartnershipsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_info_partnerships = /** @type {((inputs?: Footer_Info_PartnershipsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Info_PartnershipsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_info_partnerships(inputs)
});